import PageMeta from "~/components/common/meta";
import { Availability } from "~/components/staff/availability";

export const AvailablityScreen = () => {
  return (
    <>
      <PageMeta title="My Availabilities | Art Handler" />
      <Availability />
    </>
  );
};
